module.exports = __webpack_public_path__ + "img/activityendsicon.b76a2ed7.png";